import './auto-pan.scss';
import './auto-pan-loader';



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/auto-pan/index.js